import { EditableComment } from '@/client';
import { ComponentHelperService, RefService } from '@/server/services';
import {
  Constants,
  MgnlContent,
  PersonalizationService,
  TemplateAnnotationsService,
} from '@magnolia/frontend-helpers-base';

export const EditableComponent = ({
  content,
  index,
}: {
  content?: MgnlContent;
  index?: number;
}) => {
  const config = RefService.getConfigRef();
  const templateAnnotations = RefService.getTemplateAnnotationsRef();
  const { componentMappings, fallbackComponent } = config || {
    componentMappings: {},
    fallbackComponent: false,
  };

  const getAnnotation = () => {
    return templateAnnotations?.[content!['@path']] || '';
  };

  const variantContent = templateAnnotations
    ? PersonalizationService.getSelectedVariant(
        content || null,
        templateAnnotations
      )
    : content;
  const renderingContent = TemplateAnnotationsService.generateMissingAreas(
    variantContent,
    templateAnnotations
  );
  const component = ComponentHelperService.getRenderedComponent(
    renderingContent,
    componentMappings,
    fallbackComponent,
    index
  );
  const annotation = getAnnotation();

  return (
    content && (
      <>
        <EditableComment annotation={annotation} shouldRefresh={true} />
        {component}
        {annotation ? (
          <EditableComment annotation={Constants.END_COMPONENT_COMMENT} />
        ) : (
          <EditableComment annotation="" />
        )}
      </>
    )
  );
};
